import type { PromoCode } from '@/types';

// Mock promo codes for demo
const mockPromoCodes: PromoCode[] = [
  {
    id: '1',
    code: 'WELCOME10',
    type: 'percentage',
    value: 10,
    minOrderAmount: 50,
    maxDiscountAmount: 100,
    expiresAt: new Date('2024-12-31'),
    usageLimit: 1000,
    usedCount: 45,
    isActive: true,
  },
  {
    id: '2',
    code: 'SAVE20',
    type: 'fixed',
    value: 20,
    minOrderAmount: 100,
    expiresAt: new Date('2024-12-31'),
    usageLimit: 500,
    usedCount: 123,
    isActive: true,
  },
];

class CartService {
  private delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

  async validatePromoCode(code: string): Promise<PromoCode> {
    await this.delay(500);

    const promoCode = mockPromoCodes.find(
      p => p.code.toLowerCase() === code.toLowerCase() && p.isActive
    );

    if (!promoCode) {
      throw new Error('Código promocional inválido');
    }

    if (promoCode.expiresAt && new Date() > promoCode.expiresAt) {
      throw new Error('Código promocional expirado');
    }

    if (promoCode.usageLimit && promoCode.usedCount >= promoCode.usageLimit) {
      throw new Error('Código promocional agotado');
    }

    return promoCode;
  }
}

export const cartService = new CartService();